import { Stack, Typography, useTheme } from "@mui/material";
import moment from "moment";
import GaugeComponent from "react-gauge-component";

export default function SponsorGauge({ value, resetAt }) {
    const theme = useTheme();
    return (
        <Stack gap={1} sx={{ minWidth: 300, maxWidth: 500 }}>
            <GaugeComponent
                type="semicircle"
                arc={{
                    colorArray: [
                        //theme.palette.error.main, 
                        theme.palette.warning.main, 
                        theme.palette.success.main
                    ],
                    padding: 0.02,
                    subArcs:
                    [
                        { limit: 1 },
                        { limit: 2 },
                        { limit: 3 },
                        { limit: 4 },
                        { limit: 5 },
                    ]
                }}
                pointer={{type: "blob", animationDelay: 0 }}
                value={value}
                minValue={0}
                maxValue={5}
                labels={{
                    valueLabel: { 
                        formatTextValue: value => `${value} point${value === 1 ? '' : 's'}`,
                        style: {
                            fontSize: "35px",
                            fill: 'grey', 
                            textShadow: 'none',
                            fontWeight: 'bold'
                        },
                        matchColorWithArc: true,
                    },
                }}
            />
            <Typography variant="body2" color="text.secondary" align="center" fontStyle="italic">
                Compteur réinitialisé le {moment(resetAt).toDate().toLocaleDateString()}
            </Typography>
        </Stack>
    );
}